import { useRef, useCallback, useEffect } from 'react'

import MODAL_STYLES from './@modal/modal.module.scss'

type MODAL_TT_PROPS =
{
    show             : boolean,
    setShow          : React.Dispatch<React.SetStateAction<boolean>>,
    className       ?: string,
    toFocus         ?: React.RefObject<HTMLElement | null>,
    ariaLabelledby  ?: string,
    ariaDescribedby ?: string,
    disabledCloseBtn?: boolean
}

export default function Modal({show, setShow, className = '', toFocus, ariaLabelledby, ariaDescribedby, disabledCloseBtn, children}: MODAL_TT_PROPS & React.PropsWithChildren)
{
    const
    PREVIOUS_FOCUSABLE  = document.activeElement as HTMLElement | null,
    MODAL               = useRef<HTMLDialogElement>(null),
    TRANSITION_DURATION = useRef(210),
    TIMEOUT_ID          = useRef<number>(0),
    set                 = useCallback((): void =>
    {
        const MODAL_ELEMENT = MODAL.current!

        clearTimeout(TIMEOUT_ID.current)
    
        updateGlobalScrolling(true)
    
        MODAL_ELEMENT.showModal()

        if (toFocus) requestAnimationFrame(() => toFocus.current?.focus())
    },
    []),
    destroy = useCallback((): void =>
    {
        TIMEOUT_ID.current = setTimeout((): void =>
        {
            MODAL.current!.close()
            PREVIOUS_FOCUSABLE?.focus()
        },
        TRANSITION_DURATION.current)

        updateGlobalScrolling(false)
    },
    []),
    updateGlobalScrolling = useCallback((frozen: boolean): void => { document.documentElement.style.setProperty('overflow', frozen ? 'hidden' : '', 'important') }, []),
    close_eClick          = useCallback((): void => setShow(false), [])

    useEffect(() =>
    {
        if (!show) return

        set()

        return destroy
    },
    [show])

    return (
        <dialog
        className={`${className} ${MODAL_STYLES.modal}`}
        style={{ transitionDuration: TRANSITION_DURATION.current + 'ms' }}
        role="dialog"
        aria-labelledby={ariaLabelledby}
        aria-describedby={ariaDescribedby}
        aria-modal={show}
        ref={MODAL}
        >
            {
                !disabledCloseBtn &&
    
                <button
                className={MODAL_STYLES.close}
                type="button"
                onClick={close_eClick}
                autoFocus
                >
                    <svg
                    className={MODAL_STYLES.xmark}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                        d="M5 19L19 5M5 5L19 19"
                        stroke="currentColor"
                        strokeWidth="2.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        />
                    </svg>
                </button>
            }

            {children}
        </dialog>
    )
}